__turbopack_context__.v({
  "card": "index-module-scss-module__2DhLAq__card",
  "card__image": "index-module-scss-module__2DhLAq__card__image",
  "card__image__picture": "index-module-scss-module__2DhLAq__card__image__picture",
  "card__place": "index-module-scss-module__2DhLAq__card__place",
  "card__price": "index-module-scss-module__2DhLAq__card__price",
  "card__title": "index-module-scss-module__2DhLAq__card__title",
});
